import { ReactElement } from 'react';

import { UserBarGroup } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';

import { ConfidentialityRequestsIcon } from './confidentialityRequestsIcon/ConfidentialityRequestsIcon';
import { ConfidentialityNotificationsIcon } from './confidentialityNotificationsIcon/ConfidentialityNotificationsIcon';

export const ConfidentialityNotificationsBadge = (): ReactElement | null => {
   const canSeeRequests = protectFeature('updatingProviderData');
   const canSeeNotifications = protectFeature('creatingAppointments');

   if (!canSeeRequests && !canSeeNotifications) {
      return null;
   }

   return (
      <UserBarGroup testId={'confidentialityNotifications'}>
         {canSeeRequests ? <ConfidentialityRequestsIcon /> : null}
         {canSeeNotifications ? <ConfidentialityNotificationsIcon /> : null}
      </UserBarGroup>
   );
};
